/* Generated from the approved colour study by scripts/build_kowloon_theme_engine.js. */
(()=>{
'use strict';

// Rasterise paper once. Each frame only scales/composites these prepared textures.
const inkPaper = (() => {
  const cache=new Map();
  return (tint=[133,153,201]) => {
    const key=tint.join(',');if(cache.has(key))return cache.get(key);
    const size=640,half=size/2,unit=280;
    const mask=document.createElement('canvas'),deposit=document.createElement('canvas');
    mask.width=mask.height=deposit.width=deposit.height=size;
    const mc=mask.getContext('2d'),dc=deposit.getContext('2d');
    const m=mc.createImageData(size,size),d=dc.createImageData(size,size);
    const clamp=v=>Math.max(0,Math.min(1,v));
    for(let y=0;y<size;y++)for(let x=0;x<size;x++) {
      const dx=x-half,dy=y-half,a=Math.atan2(dy,dx),r=Math.hypot(dx,dy)/unit;
      const contour=1+.035*Math.sin(a*3)+.018*Math.sin(a*7)+.009*Math.sin(a*13+1.1);
      const grain=Math.sin(x*.61+y*.37)*Math.sin(y*.73-x*.21);
      const edge=r-contour-.0035*grain-.005*Math.sin(x*.1)*Math.sin(y*.13);
      const wet=clamp((.015-edge)/.035),alpha=wet*wet*(3-2*wet);
      const pool=.45+.3*Math.sin(a*11+1)+.2*Math.sin(a*23);
      const broad=Math.exp(-Math.pow(edge/.027,2))*.13;
      const fine=Math.exp(-Math.pow((edge+.008)/.005,2))*Math.max(0,pool)*.23;
      const i=(y*size+x)*4;
      m.data[i]=m.data[i+1]=m.data[i+2]=255;m.data[i+3]=Math.round(alpha*255);
      d.data[i]=tint[0];d.data[i+1]=tint[1];d.data[i+2]=tint[2];d.data[i+3]=Math.round((broad+fine)*255);
    }
    mc.putImageData(m,0,0);dc.putImageData(d,0,0);
    const cached={mask:mask.toDataURL(),deposit:deposit.toDataURL(),ratio:size/unit};
    // Bound memory when an owner previews many different accent colours.
    if(cache.size>=4)cache.delete(cache.keys().next().value);cache.set(key,cached);return cached;
  };
})();

function createInkArrival({overlay,content,site,width,height,origin,reach,durationMs=6400,rippleColour}) {
  const ns='http://www.w3.org/2000/svg';
  const node=(name,attrs={})=>{const el=document.createElementNS(ns,name);Object.entries(attrs).forEach(([k,v])=>el.setAttribute(k,v));return el;};
  const clamp=v=>Math.max(0,Math.min(1,v));
  const smooth=v=>{const p=clamp(v);return p*p*(3-2*p);};
  const brand=site.querySelector('.kob-colour-logo'),pigment=brand.querySelector('.kob-colour-logo-pigment');
  const box=brand.getBoundingClientRect(),scale=box.width/3000,zoom=box.width/256;
  const local={x:origin.x-box.left-window.scrollX,y:origin.y-box.top-window.scrollY},radius=256*scale;
  const root=node('svg',{width:0,height:0,'aria-hidden':'true'});root.style.position='absolute';
  const defs=node('defs');root.append(defs);overlay.append(root);
  // Keep live displacement confined to the small logo; preserve the official alpha silhouette.
  const filter=node('filter',{id:'kob-colour-logo-wet',x:'-10%',y:'-30%',width:'120%',height:'160%','color-interpolation-filters':'sRGB'});
  filter.append(node('feTurbulence',{type:'fractalNoise',baseFrequency:(.23/zoom)+' '+(.3/zoom),numOctaves:2,seed:17,result:'paper'}));
  filter.append(node('feDisplacementMap',{in:'SourceGraphic',in2:'paper',scale:1.6*zoom,xChannelSelector:'R',yChannelSelector:'G'}));
  filter.append(node('feGaussianBlur',{stdDeviation:.65*zoom}));
  const mask=node('mask',{id:'kob-colour-ink-logo',maskUnits:'userSpaceOnUse',x:0,y:0,width:box.width,height:box.height});mask.style.maskType='alpha';
  const wet=node('g',{filter:'url(#kob-colour-logo-wet)'});
  const ringA=node('path',{fill:'none',stroke:'white','stroke-width':6*box.width/256,'stroke-linecap':'round'});
  const ringB=ringA.cloneNode();
  const aheadA=ringA.cloneNode(),aheadB=ringA.cloneNode();
  aheadA.setAttribute('opacity','.22');aheadB.setAttribute('opacity','.22');
  const inner=node('path',{fill:'white'}),word=node('path',{fill:'white'});
  // Inner bloom must not reveal the ring ahead of the travelling capillary fronts.
  const innerClip=node('clipPath',{id:'kob-colour-logo-inner'});
  innerClip.append(node('circle',{cx:local.x,cy:local.y,r:239*scale}));
  inner.setAttribute('clip-path','url(#kob-colour-logo-inner)');
  wet.append(aheadA,aheadB,ringA,ringB,inner,word);mask.append(wet);defs.append(filter,innerClip,mask);
  pigment.style.maskImage='url(#kob-colour-ink-logo)';pigment.style.webkitMaskImage='url(#kob-colour-ink-logo)';brand.classList.add('kob-colour-dyeing');

  const paper=inkPaper(rippleColour);
  content.style.maskImage='url('+paper.mask+')';content.style.webkitMaskImage=content.style.maskImage;
  content.style.maskRepeat='no-repeat';content.style.webkitMaskRepeat='no-repeat';
  // Small source textures travel in document coordinates with native scrolling.
  // No document-sized canvas and no scroll handler or JS scroll-offset correction.
  const deposits=[0,.15,.31].map(lag=>{
    const image=document.createElement('img');image.className='kob-colour-deposit';image.alt='';
    image.src=paper.deposit;image.style.left=origin.x+'px';image.style.top=origin.y+'px';
    overlay.append(image);return {image,lag};
  });
  const preludeMs=Math.min(2560,durationMs*.4),wakeMs=Math.min(600,durationMs*.09);
  const arc=(progress,direction)=>{
    const start=-Math.PI*.62,end=start+direction*Math.PI*1.08*progress,pts=[];
    for(let i=0;i<=52;i++){const a=start+(end-start)*i/52;pts.push((i?'L':'M')+(local.x+Math.cos(a)*radius)+' '+(local.y+Math.sin(a)*radius));}
    return pts.join(' ');
  };
  const bloom=p=>{
    const r=540*scale*smooth(p),pts=[];
    for(let i=0;i<70;i++){
      const a=i/70*Math.PI*2,rr=r*(1+.07*Math.sin(a*5)+.03*Math.sin(a*11));
      pts.push((i?'L':'M')+(local.x+Math.cos(a)*rr)+' '+(local.y-radius*.65+Math.sin(a)*rr));
    }
    return pts.join(' ')+'Z';
  };
  const radiusAt=p=>reach*1.12*Math.pow(smooth(p),1.05);
  let logoDone=false;
  function draw(t) {
    const elapsed=t*durationMs,logoTime=elapsed/preludeMs*.4;
    const spread=clamp((elapsed-preludeMs)/(durationMs-preludeMs-wakeMs));
    overlay.dataset.stage=logoTime<.34?'logo':logoTime<.4?'hold':spread<.33?'release':spread<1?'diffusion':'wake';
    if(!logoDone) {
      ringA.setAttribute('d',arc(smooth(logoTime/.235),1));
      ringB.setAttribute('d',arc(smooth((logoTime-.025)/.27),-1));
      aheadA.setAttribute('d',arc(clamp(smooth(logoTime/.235)+.045*smooth(logoTime/.06)),1));
      aheadB.setAttribute('d',arc(clamp(smooth((logoTime-.025)/.27)+.035*smooth(logoTime/.06)),-1));
      wet.style.opacity=String(smooth(logoTime/.045));
      brand.style.setProperty('--pool',String(Math.sin(clamp(logoTime/.34)*Math.PI)*.7));
      inner.setAttribute('d',bloom(clamp((logoTime-.10)/.20)));
      const x=box.width*(.29+.64*smooth((logoTime-.16)/.18));
      word.setAttribute('d','M'+box.width*.29+' 0 H'+x+' Q'+(x-3)+' '+box.height*.3+' '+(x+2)+' '+box.height*.5+' T'+x+' '+box.height+' H'+box.width*.29+'Z');
      if(logoTime>=.34){pigment.style.maskImage='none';pigment.style.webkitMaskImage='none';logoDone=true;}
    }
    const r=radiusAt(spread),size=r*paper.ratio;
    content.style.maskSize=size+'px '+size+'px';content.style.webkitMaskSize=content.style.maskSize;
    content.style.maskPosition=(origin.x-size/2)+'px '+(origin.y-size/2)+'px';content.style.webkitMaskPosition=content.style.maskPosition;
    if(spread>=1){content.style.maskImage='none';content.style.webkitMaskImage='none';}
    const fade=Math.min(1,spread*8)*Math.min(1,(1-t)*8);
    deposits.forEach(({image,lag},i)=>{
      const s=radiusAt(spread-lag)*paper.ratio;
      image.style.opacity=String(spread<=lag?0:fade*(1-i*.22));
      image.style.transform='translate(-50%,-50%) scale('+s/640+')';
    });
    return {radius:r,spread,size,origin};
  }
  draw(0);
  return {draw,destroy(){brand.classList.remove('kob-colour-dyeing');brand.style.removeProperty('--pool');pigment.style.removeProperty('mask-image');pigment.style.removeProperty('-webkit-mask-image');}};
}

window.KobColourInk={create:createInkArrival};
})();
